class ShopAppointmentDatePickerCtrl {

    constructor($scope, $element) {

        this.$scope = $scope;
        this.$element = $element;

        this.initDatepicker();

        this.setDatePickerStartDate();

        this.setDatePickerEndDate();

        this.addDatepickerChangeDateListener();

        this.addComponentDestroyListener();
    }

    /**
     *  Init.
     */

    initDatepicker() {
        this.datepickerElement = this.$element.datepicker({
            format: "mm-dd-yyyy",
            weekStart: 1,
            maxViewMode: 'months',
            language: "ro",
            autoclose: true,
            todayHighlight: true
        });
    }

    setDatePickerStartDate() {
        this.datepickerElement.datepicker('setStartDate', new Date(this.shopAppointmentIntervals[0].date));
    }

    setDatePickerEndDate() {
        this.datepickerElement.datepicker('setEndDate', new Date(this.shopAppointmentIntervals[this.shopAppointmentIntervals.length - 1].date));
    }

    addDatepickerChangeDateListener() {
        this.datepickerElement.datepicker().on('changeDate', this.onChangeDate.bind(this));
    }

    addComponentDestroyListener() {
        this.$scope.$on('$destroy', this.onDestroyComponent.bind(this));
    }

    /**
     *  Listeners.
     */

    onChangeDate() {
        this.$scope.$evalAsync(() => {

            this.getSelectedDate();

            this.filterAppointmentIntervalsCorrespondingToSelectedDate();

            this.formatFilteredAppointmentIntervals();
        });
    }

    onDestroyComponent() {

        this.removeDatepickerChangeDateListener();
    }

    /**
     *  Main methods.
     */

    getSelectedDate() {
        this.selectedDate = this.datepickerElement.datepicker('getDate').getTime();
    }

    filterAppointmentIntervalsCorrespondingToSelectedDate() {
        let filteredAppointmentIntervals = this.shopAppointmentIntervals.filter((shopAppointmentInterval) => {
            return this.selectedDate === shopAppointmentInterval.date;
        });

        this.filteredAppointmentIntervals = filteredAppointmentIntervals.length > 0 ? filteredAppointmentIntervals[0].intervals : [];
    }

    formatFilteredAppointmentIntervals() {
        this.intervalsCorrespondingToTheSelectedDate = this.filteredAppointmentIntervals.map((interval) => {
            return {
                id: interval.from.id + '|' + interval.to.id,
                value: interval.from.hour + ' - ' + interval.to.hour
            };
        });
    }

    removeDatepickerChangeDateListener() {
        this.datepickerElement.datepicker().off('changeDate');
    }
}

ShopAppointmentDatePickerCtrl.$inject = ['$scope', '$element'];

var shopAppointmentDatePickerComponent = function() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: '<input type="text" placeholder="Data program&#259;rii">',
        scope: {},
        controller: ShopAppointmentDatePickerCtrl,
        controllerAs: 'shopAppointmentDatePickerCtrl',
        bindToController: {
            shopAppointmentIntervals: '=',
            selectedDate: '=',
            intervalsCorrespondingToTheSelectedDate: '='
        }
    };
};

export default shopAppointmentDatePickerComponent;